
























































































































































































import { IGame } from '~/store/games/types';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getOptionSlug } from '~/utils';
import PotentialGameActionButton from './PotentialGameActionButton.vue';
import _debounce from 'lodash.debounce';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

@Component({
  components: {
    PotentialGameActionButton,
  },
})
export default class GameCardPromoCarousel extends Vue {
  @Prop() gameCards!: IGame[];

  showCardButtonDialog = false;
  clickedCard: IGame | null = null;
  windowWidth = 0;
  debouncedSetWindowWidth = _debounce(this.setWindowWidth, 500);

  get swiperBreakpoints() {
    return {
      2200: {
        slidesPerView: 6.25,
        slidesPerGroup: 4,
      },
      1500: {
        slidesPerView: 5.65,
        slidesPerGroup: 4,
      },
      1350: {
        slidesPerView: 5.15,
        slidesPerGroup: 4,
      },
      1200: {
        slidesPerView: 4.65,
        slidesPerGroup: 3,
      },
      1050: {
        slidesPerView: 4.15,
        slidesPerGroup: 3,
      },
      900: {
        slidesPerView: 3.65,
        slidesPerGroup: 2,
      },
      700: {
        slidesPerView: 3.15,
        slidesPerGroup: 2,
      },
      0: {
        slidesPerView: 2.65,
        slidesPerGroup: 1,
      },
    };
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  mounted() {
    window.addEventListener('resize', this.setWindowWidth);

    const el = this.$refs?.swiperContainer as HTMLElement;
    if (!el) {
      return;
    }

    new Swiper(el, {
      slidesPerView: 2.65,
      slidesPerGroup: 1,
      modules: [Navigation, Autoplay],
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      loop: true,
      speed: 500,
      spaceBetween: 10,
      resistance: false,
      loopAddBlankSlides: true,
      navigation: {
        nextEl: '.game-card-carousel-button-next',
        prevEl: '.game-card-carousel-button-prev',
      },
      breakpoints: this.swiperBreakpoints,
    });
  }

  destroyed() {
    window.removeEventListener('resize', this.setWindowWidth);
  }

  storeGameQuery(gameCollection: string) {
    return `/store?games=${getOptionSlug({ title: gameCollection })}`;
  }

  cardClicked(activeCard: IGame) {
    this.clickedCard = activeCard;

    if (this.isMobile) {
      this.showCardButtonDialog = true;
    }
  }

  setWindowWidth(event: any) {
    this.windowWidth = event.target.innerWidth;
  }

  @Watch('windowWidth')
  hideGameButtonModal() {
    if (this.showCardButtonDialog && this.windowWidth > 959) {
      this.showCardButtonDialog = false;
    }
  }
}
